export const Empty = () => {
    return <div className="empty">Nothing here yet</div>
}
